<template>
    <nav id="sidebar">
        <div class="sidebar-header">
            <h3>Opt-Outs</h3>
        </div>
        <ul class="list-unstyled components">
            <li class="sidebar__menu-header">
                Menu
            </li>
            <li><a @click.prevent="setMode('dashboard')" :class="[mode === 'dashboard' ? 'sidebar__active' : '']"><i
                        class="far fa-cog"></i> Admin Dashboard</a></li>
            <li><a @click.prevent="setMode('management')" :class="[mode === 'management' ? 'sidebar__active' : '']"><i
                        class="far fa-folder-tree"></i> Opt-Outs Management</a></li>
            <!-- <li>
                <a href="#pageSubmenu" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">Pages</a>
                <ul class="collapse list-unstyled" id="pageSubmenu">
                    <li>
                        <a href="#">Page 1</a>
                    </li>
                    <li>
                        <a href="#">Page 2</a>
                    </li>
                    <li>
                        <a href="#">Page 3</a>
                    </li>
                </ul>
            </li> -->
        </ul>
    </nav>
</template>

<script>
import $ from 'jquery';
import 'jquery-mousewheel/jquery.mousewheel.js';
import 'malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.js';
import 'malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.css';

export default {
    name: 'admin-sidebar',
    props: {
        mode: {
            required: true
        }
    },
    methods: {
        setMode(mode) {
            this.$emit('setMode', mode);
        }
    },
    mounted() {
        // Sidebar initialization
        $("#sidebar").mCustomScrollbar({
            theme: "minimal"
        });

        $('#sidebarCollapse').on('click', function () {
            $('#sidebar, #dashboard').toggleClass('active');
            $('.collapse.in').toggleClass('in');
            $('a[aria-expanded=true]').attr('aria-expanded', 'false');
        });
    }
}
</script>

<style scoped>
.sidebar__menu-header {
    font-size: 12px;
    margin-bottom: 0px;
    padding: 14px 20px;
    color: #99abb4;
    font-weight: 600;
    text-transform: uppercase;
}

#sidebar ul.components {
    padding: 20px 0;
}

#sidebar ul li a {
    cursor: pointer;
    padding: 0px 10px;
    display: block;
    margin: 15px 10px;
    color: #607d8b;
    display: block;
    font-size: 16px;
    border-radius: 4px;
    white-space: nowrap;
    -webkit-transition: all .2s ease-out;
    -moz-transition: all .2s ease-out;
    -o-transition: all .2s ease-out;
    -ms-transition: all .2s ease-out;
    transition: all .2s ease-out;
}

#sidebar ul li a:hover {
    color: #4169e1;
    text-decoration: none;
}

#sidebar ul li.active>a,
a[aria-expanded="true"] {
    color: #fff;
    background: #4169e1;
}

a[data-toggle="collapse"] {
    position: relative;
}

.sidebar__active {
    color: #ffffff !important;
    background: #4169e1 !important;
    font-weight: 500 !important;
    -webkit-box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    padding: 8px 35px 8px 15px !important;
    border-radius: 4px !important;
}

.dropdown-toggle::after {
    display: block;
    position: absolute;
    top: 50%;
    right: 20px;
    transform: translateY(-50%);
}
</style>